import { Button, Divider, Modal } from 'antd';
import TextContent from 'resources/Text-content.json';
import './previewModal.scss';

interface IPreviewModal {
    visible: boolean;
    onCancel: () => void;
    data: any;
    download: () => void;
}

const PreviewModal = (props: IPreviewModal) => {
    const { visible, onCancel, data, download } = props;

    return (
        <Modal
            visible={visible}
            centered={true}
            className="preview-modal-wrapper"
            destroyOnClose={true}
            maskClosable={false}
            closable={false}
            bodyStyle={{ height: '450px', backgroundColor: '#222222' }}
            footer={null}
            width={700}
        >
            <div className="title">
                {TextContent?.preview}
                <Button className="position" type="primary" onClick={onCancel}>{TextContent?.regenerate}</Button>
            </div>
            <Divider className="divider"/>
            <div className="content">{data}</div>
            <div>
                <Button children={TextContent?.btn_save} type="primary" onClick={() => download()} />
            </div>
        </Modal>

    );
}

export default PreviewModal;